import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketIdentification } from '../../../../state';

interface DescriptionEditProps {
  required?: boolean;
}

const DescriptionEdit: React.FC<DescriptionEditProps> = ({ required = true }) => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketIdentification({ description: event.target.value }));
  };

  return (
    <TextField
      label="Description"
      size="small"
      multiline
      rows={3}
      fullWidth
      required={required}
      value={currentTicket?.identification.description || ''}
      onChange={handleChange}
      placeholder="Provide a detailed description of the issue or request"
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default DescriptionEdit;
